import React from 'react'

import { Container, ContentHeader } from 'components'
import { Route, useParams, Redirect } from 'react-router-dom'
import { routes } from 'routes'
import ShowPlan from './MigratePlanShow'
import ConfigPlan from './MigrateConfig'
import ConfirmPlan from './MigrationConfirm'
import { Box, Paper } from '@material-ui/core'
import { reverse } from 'named-urls'
import ContractPlanMigrateContext from 'contexts/ContractPlanMigrateContext'

const MigratePlanSteps = () => {
  const params = useParams()
  const context = React.useContext(ContractPlanMigrateContext)

  if (params.step !== 'show' && !context.data.newPlan) {
    return (
      <Redirect
        to={reverse(routes.contracts.migratePlan.steps.show, {
          contractId: params.contractId,
          contractPlanId: params.contractPlanId,
        })}
      />
    )
  }

  return (
    <Container>
      <ContentHeader title="Migrar plano" />
      <Paper>
        <Box>
          <Route
            path={routes.contracts.migratePlan.steps.show}
            component={ShowPlan}
          />
          <Route
            path={routes.contracts.migratePlan.steps.edit}
            component={ConfigPlan}
          />
          <Route
            path={routes.contracts.migratePlan.steps.confirm}
            component={ConfirmPlan}
          />
        </Box>
      </Paper>
    </Container>
  )
}

export default MigratePlanSteps
